export default class ElementBase extends HTMLElement {
    constructor() {
        super();
    }
}
